import React from 'react';
import { enableWhyDidYouRender } from './project-config.json';

const whyDidYouRender = {
  init: () => {
    if (process.env.NODE_ENV === 'development' && enableWhyDidYouRender) {
      // eslint-disable-next-line global-require
      const render = require('@welldone-software/why-did-you-render');
      render(React, {
        logOnDifferentValues: false,
        include: [
          /^LandingPage/,
          /^LandingContainer/,
          /^ContentPage/,
          /^CategoryPage/,
          /^EducationalLayout/,
          /^EducationalLayoutRenderer/,
          /^InspirationalLayout/,
          /^InspirationalLayoutRenderer/,
          /^NavigationalLayout/,
          /^NavigationalLayoutRenderer/,
          /^SponsoredContent/,
          /^BasicSponsoredBanner/,
          /^SponsoredBanner/
        ]
      });
    }
  }
};
export { whyDidYouRender };
